module.exports = __webpack_public_path__ + "img/lottery-over.67d55a40.png";